export default "__VITE_ASSET__CA6SsaC6__"